module.exports = __webpack_public_path__ + "static/media/return-request.ce141a2e.svg";